import { AdminPage } from "../features/admin/page/admin-page";
import { AppVersionPage } from "../features/app-version/page/app-version-page";
import { ChangePasswordPage } from "../features/auth/page/change-password-page";
import { ProfilePage } from "../features/auth/page/profile-page";
import { BrandCampaignPage } from "../features/brand-campaign-page/page/brand-campaign-page";
import { BrandPage } from "../features/brand/page/brand-page";
import { CompaniesPage } from "../features/companies/page/companies-page";
import { DashboardPage } from "../features/dashboard/dashboard-page";
import { ManagementBannerPage } from "../features/management-banner/page/banner-page";
import { PromotionAssignBrandPage } from "../features/promotion-assign-brand/page/promotion-assign-brand-page";
import { PromotionCampaignTypePage } from "../features/promotion-campain-type/page/promotion-campaign-type-page";
import { MODULE_ROUTE } from "./module-router";

export const dashboardRouter = [
  { path: MODULE_ROUTE.PROFILE, component: <ProfilePage /> },
  { path: MODULE_ROUTE.BRAND, component: <BrandPage /> },
  { path: MODULE_ROUTE.ADMIN, component: <AdminPage /> },
  { path: MODULE_ROUTE.CHANGE_PASSWORD, component: <ChangePasswordPage /> },
  { path: MODULE_ROUTE.PROMOTION_CAMPAIGN_TYPE, component: <PromotionCampaignTypePage /> },
  { path: MODULE_ROUTE.PROMOTION_ASSIGN_BRAND, component: <PromotionAssignBrandPage /> },
  { path: MODULE_ROUTE.BRAND_CAMPAIGNS, component: <BrandCampaignPage /> },
  { path: MODULE_ROUTE.BANNER_PAGE, component: <ManagementBannerPage /> },
  { path: MODULE_ROUTE.APP_VERSION, component: <AppVersionPage /> },
  { path: MODULE_ROUTE.COMPANIES, component: <CompaniesPage /> },
];
